import React, { useState } from 'react';

import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, AreaChart, Area } from 'recharts';

import { useTranslation } from 'react-i18next';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';

import {
    PieChart,
    Pie,
    Cell,
    ResponsiveContainer,
    Legend,
    Tooltip
} from 'recharts';

import { Card, Col, Form, Row, Tab, Tabs } from 'react-bootstrap';
const WorkLifeBalancePie = () => {

    // Prepare chart data
    type PieChartData = {
        name: string;
        value: number;
        color: string;
    };

    // Initial data setup remains the same

    type Task = {
        id: string;
        name: string;
        category: 'Professional' | 'Personal';
        timeSpent: number;
        week: number;
    };




    const initialTasks: Task[] = [
        ...Array.from({ length: 10 }, (_, i): Task => ({
            id: `work-1-${i}`,
            name: `Work Task ${i + 1}`,
            category: 'Professional',
            timeSpent: 1,
            week: 1
        })),
        ...Array.from({ length: 8 }, (_, i): Task => ({
            id: `personal-1-${i}`,
            name: `Personal Task ${i + 1}`,
            category: 'Personal',
            timeSpent: 1,
            week: 1
        })),
        ...Array.from({ length: 10 }, (_, i): Task => ({
            id: `work-2-${i}`,
            name: `Work Task ${i + 1}`,
            category: 'Professional',
            timeSpent: 1,
            week: 2
        })),
        ...Array.from({ length: 6 }, (_, i): Task => ({
            id: `personal-2-${i}`,
            name: `Personal Task ${i + 1}`,
            category: 'Personal',
            timeSpent: 1,
            week: 2
        }))
    ];


    const [tasks, setTasks] = useState(initialTasks);
    const [selectedWeek, setSelectedWeek] = useState(1);

    const COLORS: { [key: string]: string } = {
        Personal: '#f4af36',
        Professional: '#00C49F'
    };

    const preparePieChartData = (weekNumber: number): PieChartData[] => {

        const weekTasks: Task[] = tasks.filter(task => task.week === weekNumber);

        const categoryTotals = weekTasks.reduce((acc, task) => {
            acc[task.category] = (acc[task.category] || 0) + task.timeSpent;
            return acc;
        }, {} as Record<string, number>);

        // The function explicitly returns an array of PieChartData, which is defined as an object with name, value, and color.
        return Object.entries(categoryTotals).map(([name, value]) => ({
            name,
            value,
            color: COLORS[name]
        }));
    };

    const weekData = preparePieChartData(selectedWeek);


    // Function to handle input changes
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setSelectedWeek(parseInt(value));
    };

    return (
        <>
            <Card className="w-100 mb-3">
                <Card.Header>
                    <Card.Title>Work-Life Balance Analysis</Card.Title>
                    <div className="flex items-center gap-4 mt-4">
                        <Form.Label>Select Week:</Form.Label>

                        <Form.Control as="select"
                            id="role"
                            type="text"
                            className="form-icon-input"
                            value={selectedWeek.toString()}
                            name="role"
                            onChange={handleInputChange}
                        >
                            <option value="1">Week 1</option>
                            <option value="2">Week 2</option>
                        </Form.Control>
                    </div>
                </Card.Header>
                <Card.Body className="pb-2 w-100">


                    <ResponsiveContainer className="vh-50">
                        <PieChart>
                            <Pie
                                data={weekData}
                                cx="50%"
                                cy="50%"
                                labelLine={false}
                                outerRadius={80}
                                fill="#8884d8"
                                dataKey="value"
                            >
                                {weekData.map((entry, index) => (
                                    <Cell
                                        key={`cell-${index}`}
                                        fill={entry.color}
                                    />
                                ))}
                            </Pie>
                            <Tooltip />
                            <Legend />
                        </PieChart>
                    </ResponsiveContainer>

                    <div className="d-flex gap-4 mb-3">
                        <Card className='flex-grow-1'>
                            <Card.Header className='pb-0 border-bottom-0'>
                                <Card.Title className="fs-6" style={{ color: COLORS["Professional"] }}>Professional</Card.Title>
                            </Card.Header>
                            <Card.Body className='pb-0'>
                                <p className="fs-4 fw-bold">
                                    {weekData.find(d => d.name === 'Professional')?.value || 0} hrs
                                </p>
                            </Card.Body>
                        </Card>
                        <Card className='flex-grow-1'>
                            <Card.Header className='pb-0 border-bottom-0'>
                                <Card.Title className="fs-6" style={{ color: COLORS["Personal"] }}>Personal</Card.Title>
                            </Card.Header>
                            <Card.Body className='pb-0'>
                                <p className="fs-4 fw-bold">
                                    {weekData.find(d => d.name === 'Personal')?.value || 0} hrs
                                </p>
                            </Card.Body>
                        </Card>
                    </div>


                </Card.Body>
            </Card>




            <Card className="bg-theachai-floralwhite mb-3">
                <Card.Header className='pb-0 border-bottom-0'>
                    <Card.Title className="fs-6 fw-bold">Current Balance Analysis</Card.Title>
                </Card.Header>
                <Card.Body>
                    <p className="fs-7 mb-2">
                        Week {selectedWeek} shows a {weekData.find(d => d.name === 'Professional')?.value || 0}/{weekData.find(d => d.name === 'Personal')?.value || 0} work/personal split.
                    </p>
                    <p className="fs-7">
                        Target: Aim for a 40-60% split between work and personal time for optimal balance.
                    </p>
                </Card.Body>
            </Card>
        </>

    );
};

export default WorkLifeBalancePie;